import appConfigs from "./app";
import serverConfigs from "./server";

const configs = {
    appConfigs,
    serverConfigs
}

export default configs;